'use strict';

angular.module('admin').controller('AdminChangeUserSubscriptionController',
	['$scope', 'AdminData', 'Authentication', 'Utilities', '$stateParams', '$window',
		function($scope, AdminData, Authentication, Utilities, $stateParams, $window) {
			$scope.authentication = Authentication;
			$scope.data = {
				userId: $stateParams.userId,
				userInfo: undefined,
				newPlan: 'free',
				enterprisePlanData: {},
				plans: [{
					id: 'enterprise',
					name: 'Enterprise',
					price: 0
				}]
			};

			$scope.processing = false;


			/**
			 * Load all the data
			 */
			$scope.init = function() {

				AdminData.userInfo({userId: $scope.data.userId}, function (userInfo) {
					$scope.data.userInfo = userInfo;

					$scope.data.newPlan = userInfo._planInfo.id;

					if (userInfo._planInfo.id === 'enterprise') {
						$scope.data.enterprisePlanData = userInfo.enterprisePlan;
					} else {
						$scope.data.enterprisePlanData = {
							apps: 10,
							teamMembers: 30,
							mau: 1000000,
							glossary: true,
							xtmIntegration: false,
							appstoreIntegration: false,
							backupsAutomatic: 10,
							backupsManual: 10
						};
					}

				}, function (err) {
					console.log(err);
					Utilities.showMessage(
						'Problem!',
						'Problem loading user info',
						'error'
					);
				});

				AdminData.availablePlans({}, function (availablePlans) {

					// Get rid of all the promise data
					availablePlans = JSON.parse(angular.toJson(availablePlans));

					// Add all the plans to be displayed
					Object.keys(availablePlans).forEach(function(planId) {
						$scope.data.plans.push(availablePlans[planId]);
					});

				}, function (err) {
					console.log(err);
					Utilities.showMessage(
						'Problem!',
						'Problem loading plans',
						'error'
					);
				});

			};


			/**
			 * Change the subscription
			 */
			$scope.changeSubscription = function() {
				$scope.processing = true;

				var sendData = {
					userId: $scope.data.userId,
					planId: $scope.data.newPlan
				};

				if ($scope.data.newPlan === 'enterprise') {
					// If enterprise plan got choosen add the plan data
					sendData.enterprisePlanData = $scope.data.enterprisePlanData;
				}

				// Send the new data to server
				AdminData.changeUserSubscription(sendData, function (returnData) {

					$scope.processing = false;

					Utilities.showMessage(
						'Success',
						'The plan got changed',
						'success',
						function() {
							// Simply refresh the page so that all data gets newly loaded
							$window.location.reload();
						}
					);


				}, function (error) {

					var errorMessage = 'There was a problem updating the subscription!';
					if (error.data && error.data.message) {
						errorMessage = 'There was a problem: <br />' + error.data.message;
					}

					$scope.processing = false;

					Utilities.showMessage(
						'Problem!',
						errorMessage,
						'error'
					);

				});
			};


			$scope.init();
		}
	])


	/**
	 * Allows to easily filter for free plans
	 */
	.filter('onlyFreePlans', function () {
		return function (input, onlyFree) {
			var output = [];

			if (onlyFree === true) {
				// Return only free plans
				angular.forEach(input, function (item) {
					if (item.price === 0) {
						output.push(item);
					}
				});
			} else {
				// Return all plans
				output = input;
			}

			return output;
		};
	});
